import React from "react";
import _ from "lodash";
import Container from "react-bootstrap/esm/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import ListGroup from "react-bootstrap/ListGroup";
import { toast } from "react-toastify";
import PlannedTournamentApi from "../api/plannedTournamentApi";
import Stack from "react-bootstrap/esm/Stack";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import ButtonGroup from "react-bootstrap/esm/ButtonGroup";

class PlannedTournamentSelector extends React.Component {
  state = {
    processing: false,

    plannedTournaments: [],
  };

  async componentDidMount() {
    await this.loadPlannedTournaments();
  }

  loadPlannedTournaments = async () => {
    this.setState({ processing: true });

    const { success, data: plannedTournaments, message } = await PlannedTournamentApi.getAll();

    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournaments, processing: false });
  };

  handleDelete = async (plannedTournamentId) => {
    this.setState({ processing: true });

    const { plannedTournaments } = this.state;

    const { success, message } = await PlannedTournamentApi.deleteOne(plannedTournamentId);
    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    _.remove(plannedTournaments, (t) => t.plannedTournamentId === plannedTournamentId);

    this.setState({ plannedTournaments, processing: false });
    toast.success("Tournament deleted");
  };

  handleCopy = async (plannedTournamentId) => {
    this.setState({ processing: true });

    let { plannedTournaments } = this.state;

    let { success, message } = await PlannedTournamentApi.copy(plannedTournamentId);
    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    ({ success, data: plannedTournaments, message } = await PlannedTournamentApi.getAll());
    if (!success) {
      this.setState({ processing: false });
      toast.error(message);
      return;
    }

    this.setState({ plannedTournaments, processing: false });
    toast.success("Tournament copied");
  };

  render() {
    const plannedTournaments = _.chain(this.state.plannedTournaments).orderBy("date", "desc").value();

    return (
      <React.Fragment>
        <Modal show={this.state.processing} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Body>Processing...</Modal.Body>
        </Modal>
        <Container fluid>
          <Row>
            <Col>
              <h1>
                Planned Tournaments:{" "}
                <Button variant="primary" href={`${process.env.PUBLIC_URL}/?planned=`}>
                  New
                </Button>
              </h1>
              {plannedTournaments.length === 0 && (
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              <ListGroup>
                {plannedTournaments.map((plannedTournament) => {
                  return (
                    <ListGroup.Item action key={plannedTournament.plannedTournamentId} as="div">
                      <Stack direction="horizontal" gap="1">
                        <ButtonGroup>
                          <Button variant="danger" size="sm" onClick={(e) => this.handleDelete(plannedTournament.plannedTournamentId)}>
                            DEL
                          </Button>
                          <Button variant="primary" size="sm" onClick={(e) => this.handleCopy(plannedTournament.plannedTournamentId)}>
                            COPY
                          </Button>
                        </ButtonGroup>
                        <Nav.Link href={`${process.env.PUBLIC_URL}/?planned=${plannedTournament.plannedTournamentId}`}>
                          {plannedTournament.state} - {plannedTournament.name}
                        </Nav.Link>
                      </Stack>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default PlannedTournamentSelector;
